import { Pipe, PipeTransform } from '@angular/core';

// collapseProviders takes a Trace.providers (or Request.provider) string
// — which can carry consumer-intent verbatim ("*" or a comma-separated
// list like "EK,CM,AV,BA,A3" from the sidecar capture path) — and
// renders it as "*" when it represents fan-out. Single-provider values
// are returned as-is. Empty / null / undefined inputs render as
// "(not set)" so the caller doesn't have to guard.
//
// Mirrors the `isMultiProviderIntent` check in the backend's
// api_controller.go and the `TraceUtilsService.getProviders` pipe used
// for the dashboard tile, so trace.providers reads consistently
// everywhere.
@Pipe({
  name: 'collapseProviders',
})
export class CollapseProvidersPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '(not set)';
    if (value === '*' || value.includes(',')) return '*';
    return value;
  }
}
